module.exports = __webpack_public_path__ + "img/icon-editor.87102af8.svg";